import React      from 'react'
import { Helmet } from 'react-helmet'

import { formatText } from './format'

export default function Meta(props) {
  let title       = props.data.content.site_title
  let description = props.data.content.site_description
  let image       = props.data.media_host + 'banner.jpg'
  if (props.item) {
    title       = props.item.name || props.item.title || (props.item.item && props.item.item.title) || title
    description = props.item.description || props.item.content || props.item.caption || description
    image       = props.item.small_url || image
  }
  if (title !== props.data.content.site_title) {
    title = props.data.content.site_title + ': ' + title
  }
  title = title && formatText(title)
  if (title.length > 70) {
    title = title.slice(0, 67) + '...'
  }
  description = description && formatText(description)
  if (description.length > 120) {
    description = description.slice(0, 117) + '...'
  }
  return (
    <Helmet>

      {title        && <title>{title}</title>}
      {description  && <meta name="description" content={description} />}

      {props.root   && <meta name="twitter:card"        content="summary" />}
      {title        && <meta name="twitter:title"       content={title} />}
      {description  && <meta name="twitter:description" content={description} />}
      {image        && <meta name="twitter:image"       content={image} />}
      {props.root   && <meta name="twitter:site"        content={props.data.content.twitter} />}
      {props.root   && <meta name="twitter:creator"     content={props.data.content.twitter} />}

      {title        && <meta property="og:title"        content={title} />}
      {description  && <meta property="og:description"  content={description} />}
      {image        && <meta property="og:image"        content={image} />}
      {props.root   && <meta property="fb:admins"       content={props.data.content.facebook} />}

    </Helmet>
  )
}



// WEBPACK FOOTER //
// ./src/components/meta.js